import { Component } from 'preact';
import PropTypes from 'prop-types';

export default class ItemVehicle extends Component {
  render() {
    const { modelName, unit, thumb, thumbAlt, price } = this.props;

    return (
      <div className="financing-simulador__card">
        <div className="row">
          <div className="img-model col-sm-12 col-md-3">
            <img
              className="financing-simulador__card__img img-fluid"
              src={thumb}
              alt={thumbAlt}
            />
          </div>

          <div className="data-model col-sm-12 col-md-9">
            <div className="financing-simulador__card__top">
              <div className="summary__info-item">
                <h4 className="bold-label">Modelo: </h4>
                <p className="financing-summary-info__value">{modelName}</p>
              </div>

              <div className="summary__info-item">
                <h4 className="bold-label">Valor do modelo: </h4>
                <p className="financing-summary-info__value">R$ {price}</p>
              </div>

              {unit && (
                <div className="summary__info-item">
                  <h4 className="bold-label">Unidade: </h4>
                  <p className="financing-summary-info__value">{unit}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ItemVehicle.propTypes = {
  modelName: PropTypes.string,
  unit: PropTypes.string,
  thumb: PropTypes.string,
  thumbAlt: PropTypes.string,
  price: PropTypes.number,
};
